import React from 'react'
import PropTypes from 'prop-types'

import styles from './index.css'


export default class PageControl extends React.Component {

  static propTypes = {
    page      : PropTypes.number,
    numPages  : PropTypes.number,
    radius    : PropTypes.number,
    onChange  : PropTypes.func
  }

  static defaultProps = {
    page      : 1,
    radius    : 3,
    numPages  : 1,
  }

  constructor(props) {
    super(props)
    this.previousPage = this.previousPage.bind(this)
    this.nextPage = this.nextPage.bind(this)
    this.goToPage = this.goToPage.bind(this)
  }

  goToPage(page) {
    if (this.props.onChange) {
      this.props.onChange(page)
    }
  }

  previousPage() {
    if (this.props.page-1 >= 1) {
      this.goToPage(this.props.page-1)
    }
  }

  nextPage() {
    if (this.props.page+1 <= this.props.numPages) {
      this.goToPage(this.props.page+1)
    }
  }

  render() {
    const { page, radius, numPages } = this.props
    
    let left = page - radius
    left += Math.max(1, left) - left

    let right = left + 2*radius 
    right += Math.min(numPages, right) - right
    left = right - 2*radius

    const start = Math.max(1, left)
    const end   = Math.min(numPages, right)

    const numInternals = end-start+1
    let internalButtons = null 
    
    if (numInternals > 0) {
      internalButtons = new Array(numInternals)
      for (let i = internalButtons.length-1; i >= 0; --i) {
        const classes = [styles.pbutton]
        if (start+i == page) classes.push(styles.active)

        internalButtons[i] = (
          <button 
            key={i} 
            type="button" 
            className={classes.join(' ')}
            onClick={() => this.goToPage(start+i)}>
            {start + i}
          </button>
        )
      }
    }

    return (
      <div className={styles.PageControl}>
        <button type="button" className={[styles.pbutton, styles.leftmost].join(' ')} onClick={this.previousPage}>
          <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12">
              <path fill="#000" fillRule="evenodd" d="M7.41 1.41L6 0 0 6l6 6 1.41-1.41L2.83 6z"/>
          </svg>
        </button>
        {internalButtons}
        <button type="button" className={[styles.pbutton, styles.rightmost].join(' ')} onClick={this.nextPage}>
          <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12">
              <path fill="#000" fillRule="evenodd" d="M.59 1.41L2 0l6 6-6 6-1.41-1.41L5.17 6z"/>
          </svg>
        </button>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/PageControl/index.jsx